import { GlobalState } from "src/reducers";

export const selectOpenBuyExtensions = (state: GlobalState) =>
    state.entities.openBuyExtensions;
export const selectOpenBuyExtensionsLoading = (state: GlobalState) =>
    state.ui.adminTools.extensions.isLoading;
export const selectOpenBuyExtensionsError = (state: GlobalState) =>
    state.ui.adminTools.extensions.isError;
